import styled, { css } from "styled-components"

const styledSection = css`
  display: block;
  max-width: 1140px;
  position: relative;
  margin: 0 auto;
`

export const StyledHeaderSection = styled.section`
  border-bottom: 1px solid;

  h1 {
    font-size: 2.45em;
  }

  p {
    display: none;
  }
`
export const StyledRow = styled.main`
  ${styledSection};

  @media (max-width: 1199px) {
    margin-left: 20px;
    margin-right: 20px;
  }
  padding: 50px 0;
`

export const StyledJobsSection = styled.section`
  ${styledSection};
  background: white;

  @media (max-width: 1199px) {
    margin-left: 30px;
    margin-right: 30px;
  }
`

export const StyledColumn = styled.div`
  max-width: 550px;
  &::after {
    background: url("/g-static/nimbus/hero1_bg_graphic.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 0 0;
    content: "";
    height: 500px;
    left: 650px;
    position: absolute;
    bottom: 0;
    width: 500px;
    z-index: -1;

    @media (max-width: 991px) {
      height: 300px;
      left: auto;
      right: 0;
      bottom: auto;
      width: 300px;
    }
  }

  @media (max-width: 991px) {
    padding-bottom: 80px;
  }
`
